import { render, staticRenderFns } from "./Salve.vue?vue&type=template&id=7fe44a31&"
import script from "./Salve.vue?vue&type=script&lang=js&"
export * from "./Salve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports